import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: { paddingTop: 0, paddingBottom: 0 },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: {
        color: '#6948EB',
        '& + .MuiTypography-root': {
          fontWeight: 500,
          color: 'rgba(7, 27, 58, 0.8)',
        },
      },
    },
    {
      props: { color: 'error' },
      style: {
        color: '#E02727',
      },
    },
  ],
};
